import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;

export const EmptyItem = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  font-size: 18px;
  padding-top: 30px;
`;

